import { jsx as _jsx } from "react/jsx-runtime";
import PangeaLayout from "./pangea";
import HostedLayout from "./hosted";
var Layout = function (_a) {
    var branding = _a.branding, isPangea = _a.isPangea, children = _a.children;
    var urlParams = new URLSearchParams(window.location.search);
    var pmParam = urlParams.get("pm");
    if (isPangea && !!pmParam) {
        // if pangea and has pm=mlp (marketing left panel) flag
        return _jsx(PangeaLayout, { contentKey: pmParam, children: children });
    }
    else {
        return _jsx(HostedLayout, { branding: branding, children: children });
    }
};
export default Layout;
